import "../../types/customizer-global";
import selectSingleElement from "../dom/selectSingleElement";

const CANVAS_WIDTH = 576;
const CANVAS_HEIGHT = 497;

function generateCanvas({
  color = "transparent",
  text = "",
  id,
  withStroke = false,
  strokeXRatio = 2,
  strokeYRatio = 2.475,
  lineWidth = 2,
  font = window.currentCustomizerFont || "HoodScript",
}: {
  color?: string;
  text?: string;
  id?: string;
  withStroke?: boolean;
  strokeXRatio?: number;
  strokeYRatio?: number;
  lineWidth?: number;
  font?: string;
}) {
  console.log("generate canvas", font);
  const canvasElement = document.getElementById("pplr_canvas") as HTMLCanvasElement;
  const currentCanvasElement = canvasElement?.getContext("2d");
  const newCanvas = document.createElement("canvas");
  const spanWrapper = document.createElement("span");
  const ctx = newCanvas.getContext("2d");
  const previewWrapper = selectSingleElement(".pplr_preview_wrapper");
  const carouselWrapper = selectSingleElement("media-gallery");

  const currentCanvasWidth = currentCanvasElement?.canvas.width ?? CANVAS_WIDTH;
  const currentCanvasHeight = currentCanvasElement?.canvas.height ?? CANVAS_HEIGHT;

  if (
    typeof newCanvas !== "undefined" &&
    ctx !== null &&
    currentCanvasElement !== null
  ) {
    newCanvas.id = `${id}-canvas`;
    newCanvas.width = currentCanvasWidth;
    newCanvas.height = currentCanvasHeight;
    ctx.textAlign = "center";
    ctx.textBaseline = currentCanvasElement.textBaseline;
    ctx.lineWidth = lineWidth;
    ctx.strokeStyle = color;

    const strokeX = currentCanvasWidth / strokeXRatio;
    const strokeY = currentCanvasWidth / strokeYRatio;
    const maxWidth = (currentCanvasWidth * 70) / 100;

    console.log("font size", currentCanvasElement.font.split(" ")[0], font);
    const newFontSize = 66;

    // Only set default text if we're not dealing with an outline canvas
    // For outline, we want to show nothing if there's no text
    if (Number(ctx.measureText(text).width) <= 0 && id !== "outline") {
      text = "Custom";
    }
    ctx.font = `${newFontSize}px ${font}`;
    console.log("text", ctx.font, Number(ctx.measureText(text).width));

    if (withStroke && text) {
      ctx.strokeText(text, strokeX, strokeY, maxWidth);
    }

    spanWrapper.id = `${id}-canvas-wrapper`;
    spanWrapper.style.width = previewWrapper
      ? previewWrapper.style.width
      : String(CANVAS_WIDTH);
    spanWrapper.style.height = previewWrapper
      ? previewWrapper.style.height
      : String(CANVAS_HEIGHT);

    if (document.getElementById(`${id}-canvas`)) {
      const oldCanvas = document.getElementById(`${id}-canvas`);
      oldCanvas?.remove();
    }
    if (document.getElementById(`${id}-canvas-wrapper`)) {
      const oldCanvasWrapper = document.getElementById(`${id}-canvas-wrapper`);
      oldCanvasWrapper?.remove();
    }
    spanWrapper.appendChild(newCanvas);
    if (carouselWrapper) carouselWrapper.appendChild(spanWrapper);
  }
}

export default generateCanvas;
